import { node, string } from 'prop-types';

const BetHeaderItem = ({ className, children }) => (
  <div className={`betheader-item ${className}`}>{children}</div>
);

BetHeaderItem.propTypes = {
  className: string.isRequired,
  children: node.isRequired,
};

export default BetHeaderItem;
